import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLandmark extends Layout {
    dataheaderMobileCommLandmark: DataHeader;
    panelMobileCommLandmark: Panel;
    sourceMobileCommLandmark: DataSource;
    switchIsActive: Switch;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
}
